import { createContext, useContext } from 'react';

import type { IORGANIZATION } from '../constants/global';

export const OrganizationContext = createContext<IORGANIZATION | null>(null);

export const useOrganizationContext = (): IORGANIZATION => {
	const organizationContext = useContext(OrganizationContext);

	if (!organizationContext) {
		throw new Error('useOrganizationContext must be used within a GlobalProvider');
	}

	return {
		...organizationContext,
	};
};
